module.exports = __webpack_public_path__ + "static/media/data_download.35172eea.webp";